// Mise en page éditoriale sans bibliothèque d'animation : le contenu est visible
// dès le HTML pré-rendu et aucune animation ne retarde son affichage.
export const Line = ({ children, className = "" }) => (
  <span className={`block ${className}`}>{children}</span>
);

export const Reveal = ({ children, className = "" }) => <div className={className}>{children}</div>;

export const SectionTag = ({ children, className = "" }) => (
  <p className={`font-mono text-xs uppercase tracking-[0.25em] text-ink/60 ${className}`}>
    {children}
  </p>
);
